<!-- <div class="dynamic_wrapper d-none">
    <div class="inner_dynamic_sec text-center">
        <app-back-to-home></app-back-to-home>
        <div class="top_process_section">
            <div class="d-flex justify-content-center">
                <span class="icon-tick-fill1 icon_green"></span>
                <img src="assets/images/line.png" class="line_cross m-2 p-1">
                <span class="icon-tick-fill1 icon_green"></span>
                <img src="assets/images/line.png" class="line_cross m-2 p-1">
                <span class="icon-tick-fill1 icon_blue"></span>
            </div>
            <div class="container_content_sec">
                <div class="inner_container_content">
                    <div class="loading_div analysing_sec">
                        <div class="img_section text-center position-relative">
                            <div class="analyzing_text">
                                <div class="title_sec mt-4">
                                    <h4 class="thank_you_head"><b>Thank you!</b></h4>
                                </div> -->
                                <!-- <p>This is the first step you are taking towards a healthy mouth and life.</p> -->
                        <!--     </div>
                            <div class="loader_img_sec">
                                <img src="assets/images/loader.gif" />
                            </div>
                            <div class="analyzing_text mb-4"> -->
                                <!-- <p class="thank_you_head"><b>Please Wait!</b></p> -->
                        <!--         <p>Please wait while our AI engine is analysing your photos</p>
                            </div>
                        </div>
                    </div>
                    <div class="sec_inner_content">
                        <div class="vs-messages mb-2"></div>
                        <div class="title_sec mb-4">
                            <h4 class="heading">Please upload at least three (3) mouth selfies</h4>
                            <p class="agree_text d-flex align-items-center justify-content-center">Please click on<span class="icon-info1 info_icon p-0 font_18 mx-1 cursor_pointer" (click)="openModal(template)"></span>icon for instructions</p>
                            <p class="my-2 content_max_width">Our AI engine will analyse your uploaded images and provide you the Oral Health Rating.</p>
                            <ng-template #template>
                                <div>
                                </div>
                                <div class="vs-messages-modal px-3 text-center"></div>
                                <div class="modal-body vertical_scroll">
                                    <div class="model_section p-4">
                                        <div class="cancel_button_sec text-right">
                                            <a class="close close_button" data-dismiss="modal" aria-label="Close" (click)="closeModal()"> <span class="icon-fill-close1"></span> </a>
                                        </div>
                                        <div class="nav_buttons d-flex justify-content-center">
                                            <ul class="nav nav-pills justify-content-center" id="pills-tab" role="tablist">
                                                <li class="nav-item modal_link_border videos_tab_li">
                                                    <a class="nav-link active" id="videos-tab" data-toggle="pill" href="#videos" role="tab" aria-controls="pills-home" aria-selected="true">Videos</a>
                                                </li>
                                                <li class="nav-item modal_link_border videos_tab_li">
                                                    <a class="nav-link" id="instructions-tab" data-toggle="pill" href="#instructions" role="tab" aria-controls="pills-profile" aria-selected="false">Instructions</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="model_content_section">
                                            <div class="tab-content" id="pills-tabContent">
                                                <div class="tab-pane fade show active" id="videos" role="tabpanel" aria-labelledby="videos-tab">
                                                    <div class="">
                                                        <div class="head_para">
                                                            <P class="theme_color py-3 font_w_600  font_16 text-center">Watch the help videos and follow the instructions </P>
                                                        </div>
                                                        <div class="inner_videos">
                                                            <div class="row">
                                                                <div class="col-sm-12 mb-6">
                                                                    <div class="embed-responsive embed-responsive-16by9">
                                                                        <iframe class="embed-responsive-item player yt_players" id="player0" [src]="youtube_1" allowfullscreen></iframe>
                                                                    </div>
                                                                    <figcaption class="figure-caption text-center mt-2 mb-3 font_w_600"> Teeth Front View </figcaption>
                                                                </div>
                                                                <div class="col-sm-12 mb-6">
                                                                    <div class="embed-responsive embed-responsive-16by9">
                                                                        <iframe class="embed-responsive-item player yt_players" id="player1" [src]="youtube_2" allowfullscreen></iframe>
                                                                    </div>
                                                                    <figcaption class="figure-caption text-center mt-2 mb-3 font_w_600">Teeth Right View</figcaption>
                                                                </div>
                                                                <div class="col-sm-12 mb-6">
                                                                    <div class="embed-responsive embed-responsive-16by9">
                                                                        <iframe class="embed-responsive-item player yt_players" id="player2" [src]="youtube_3" allowfullscreen></iframe>
                                                                    </div>
                                                                    <figcaption class="figure-caption text-center mt-2 mb-3 font_w_600">Teeth Left View</figcaption>
                                                                </div>
                                                                <div class="col-sm-12 mb-6">
                                                                    <div class="embed-responsive embed-responsive-16by9">
                                                                        <iframe class="embed-responsive-item player yt_players" id="player3" [src]="youtube_4" allowfullscreen></iframe>
                                                                    </div>
                                                                    <figcaption class="figure-caption text-center mt-2 mb-3 font_w_600">Teeth Upper Jaw</figcaption>
                                                                </div>
                                                                <div class="col-sm-12 mb-6">
                                                                    <div class="embed-responsive embed-responsive-16by9">
                                                                        <iframe class="embed-responsive-item player yt_players" id="player4" [src]="youtube_5" allowfullscreen></iframe>
                                                                    </div>
                                                                    <figcaption class="figure-caption text-center mt-2 mb-3 font_w_600">Teeth Lower Jaw</figcaption>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="tab-pane fade" id="instructions" role="tabpanel" aria-labelledby="instructions-tab">
                                                    <div class="mb-3 mx-2 ">
                                                        <div class="head_para">
                                                            <P class="theme_color py-3 font_w_600  font_16 text-center"> Recommended procedure to get your Oral Health Rating</P>
                                                        </div>
                                                        <div class="inner_points text-left">
                                                            <ul class="instruction_points">
                                                                <li class="mb-3">
                                                                    Use a smart phone that comes with a high-resolution camera to take pictures of your smile.
                                                                </li>
                                                                <li class="mb-3">
                                                                    Stand in front of a plain background (such as a wall) to capture bright quality images.
                                                                </li>
                                                                <li class="mb-3">
                                                                    It is recommended that you use flash on the camera display screen.
                                                                </li>
                                                                <li class="mb-3">
                                                                    For flash to produce high quality pictures. Maintain an adequate distance between camera and mouth.
                                                                </li>
                                                                <li class="mb-3">
                                                                    Ensure that unwanted structures are not captured and place camera accordingly.
                                                                </li>
                                                                <li class="mb-3">
                                                                    Ask a friend or a family member to help out, especially if you can't take it yourself!.
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                        <div class="img_section">
                            <form autocomplete="off" [formGroup]="InputForm">
                                <div class="row text-center text-lg-left inner_row">
                                    <div class="form-group col-lg-4 col-md-6 col-sm-6 col-12 mb-4 margin_bottom" [ngClass]="{'mt-sm-3': i == '4' || i == '3' || i == '5'}" *ngFor="let data of responseData let i = index" id="{{i}}">
                                        <div class="upload_preview">
                                            <div>
                                                <label class="teeth_img_sec  image_upload{{i}} cursor_pointer position-relative" for="image_upload{{i}}"></label>
                                                <div id="overlay{{i}}"></div>
                                                <span class="upload_preview_span{{i}}"></span>
                                                <p class="please_wait_msg{{i}}"></p>
                                                <div class="upload_inner_section{{i}}">
                                                    <div class="position-relative">
                                                        <img [defaultImage]="defaultImage" [lazyLoad]="data.url" class="score_one" [errorImage]="defaultImage" *ngIf="data.base64==''">
                                                        <span class="icon-info1 custom_style_icon cursor_pointer" (click)="openViewModal(template2,i)" id="elementID"></span>
                                                    </div>
                                                    <div class="avatar-preview cropping avatar_preview{{i}}" *ngIf="data.base64!=''">
                                                        <img src="{{data.base64}}" [ngClass]="{'base64Image': i != '5'}" id=uploadImage{{i}}>
                                                        <label for="image_upload{{i}}" class="icon_edit"><i class="icon-edit11 font_16"></i></label>
                                                    </div>
                                                </div>
                                                <div *ngIf="i == '5'" class="input_box d-none align-items-center mt-3 fig_cap">
                                                    <input PasteRestrictDirective type="text" class="firstletter_capital form_control txt_only" id="txtName" maxlength="25" (keydown)="$event.keyCode == 13 ? $event.preventDefault() : null" />
                                                    <span class="icon-tick-fill1 icon_agree cursor_pointer" (click)="CopyToLabel(i)"></span>
                                                </div>
                                                <figcaption class="figure-caption text-center fig_cap font-weight-bolder">
                                                    <span (click)="displayInputBox(i)" [ngClass]="{'cursor_pointer': i == '5'}" id="lblName{{i}}">{{data.title}}</span>
                                                </figcaption>
                                                <div class="file_upload">
                                                    <input type="file" formControlName="file{{i}}" accept="image/*" class="file" (change)="openCropperDialog($event,i,data.name)" id="image_upload{{i}}" hidden />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center col-sm-12 mt-4 submit_btn">
                                    <button class="btn button_links mr-1 btn_width_1 continue_btn btn_color">Continue</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <app-footer></app-footer>
                </div>
            </div>
        </div>
    </div>
</div> --> 

<div class="dynamic_wrapper">
    <div class="vs-messages"></div>
    <div class="dms_wrapper">
        <app-back-to-home></app-back-to-home>
        <div class="dms_content">
            <div class="loading_div analysing_sec">
                <div class="img_section text-center position-relative">
                    <div class="analyzing_text">
                        <div class="title_sec mt-4">
                            <h4 class="thank_you_head"><b>Thank you!</b></h4>
                        </div>
                        <!-- <p>This is the first step you are taking towards a healthy mouth and life.</p> -->
                    </div>
                    <div class="loader_img_sec">
                        <img src="assets/images/loader.gif" />
                    </div>
                    <div class="analyzing_text mb-4">
                        <!-- <p class="thank_you_head"><b>Please Wait!</b></p> -->
                        <p>Please wait while we uploading your photos</p>
                    </div>
                </div>
            </div>
            <div class="sec_inner_content1 p-0">
                <!-- <div class="processing">
                    <img src="assets/images/step1.png" alt="image">
                </div> -->
                <div id="steps">
                    <div id="circles" class="circle-steps">
                        <div data-num="1" id="num1"></div>
                        <div data-num="2" class="disabled" id="num2"></div>
                        <div data-num="3" class="disabled" id="num3"></div>
                    </div>
                </div>
                <form autocomplete="off" [formGroup]="InputForm" (ngSubmit)="onSubmit()">
                    <div class="row main_row">
                        <div class="col-lg-4 col-md-12 col-sm-12 text-center col_1">
                            <h3 class="sub_head mb-4 media_head">Upload at least <br> 1 photo of <br> your teeth</h3>
                            <h3 class="sub_head mb-4 responsive_head">Upload at least 1 photo of your teeth</h3>
                            <div class="grey_color">
                                <p class="mb-2 font_14">Our team will analyse the photos and give you an advise based on the images uploaded.</p>
                            </div>
                            <div class="select_btn apply_btn text-center media_button">
                                <button disabled class="upload-teeth-continue-btn btn button_links btn_width_2 coninue_btn btn_color mx-0 mt-3 justify-content-center align-items-center"><span class="save_continue_btn_span">Upload Photos</span><span class="icon_arrow icon-right-arrow ml-3 font_12"></span></button>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12 col_2">
                            <div class="img_section">
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-12 p-2" *ngFor="let data of responseData let i = index" id="{{i}}">
                                        <div class="teeth_col position-relative" class="upload_inner_section{{i}}">
                                            <div *ngIf="data.base64==''">
                                                <div class="white_bg p-2">
                                                    <!--
                                                    <p class="blue_color font_10">{{data.title}}</p>
                                                    <p class="grey_color font_10">{{data.content}}</p>
                                                    -->
                                                    <div class="d-flex justify-content-between align-items-center font_14">
                                                        <p class="blue_color font_10">{{data.title}}</p>
                                                         <span class="icon-information grey_color cursor_pointer" (click)="openViewModal(template2,i)"></span>
                                                     </div>
                                                     <p class="grey_color font_10">{{data.content}}</p>
                                                </div>
                                                <div>
                                                    <div class="position-relative teeth_images">
                                                        <img [defaultImage]="defaultImage" [lazyLoad]="data.url" class="score_one" [errorImage]="defaultImage">
                                                        <span class="icon-info1 custom_style_icon cursor_pointer" (click)="openViewModal(template2,i)" id="elementID"></span>
                                                    </div>
                                                </div>
                                                <div class="overlay1"></div>
                                                <div class="camera_sec">
                                                    <span class="icon-camera icon_camera blue_color"></span>
                                                </div>
                                            </div>
                                            <div id="overlay1{{i}}"></div>
                                            <span class="upload_preview_span{{i}}"></span>
                                            <p class="please_wait_msg{{i}}"></p>
                                            <div class="avatar-preview cropping avatar_preview{{i}}" *ngIf="data.base64!=''">
                                                <img src="{{data.base64}}" [ngClass]="{'base64Image': i != '5'}" id=uploadImage{{i}}>
                                                <label for="image_upload{{i}}" class="icon_edit"><i class="icon-edit11 font_16"></i></label>
                                            </div>
                                            <label class="teeth_img_sec  image_upload{{i}} cursor_pointer" for="image_upload{{i}}"></label>
                                        </div>
                                        
                                        <div class="file_upload">
                                            <input type="file" formControlName="file{{i}}" accept="image/*" class="file" (change)="openCropperDialog($event,i,data.name)" id="image_upload{{i}}" hidden />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="select_btn apply_btn text-center responsive_button">
                                <button disabled class="upload-teeth-continue-btn btn button_links btn_width_2 coninue_btn btn_color mx-0 mt-3 justify-content-center align-items-center"><span class="save_continue_btn_span">Upload Photos</span><span class="icon_arrow icon-right-arrow ml-3 font_12"></span></button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>


<!-- <div class="modal fade" id="myModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-hidden="true">
    <div class="vertical_alignment_modal_helper">
        <div class="modal-dialog vertical-align-center">
            <div class="modal_dialog_wrap">
                <div class="modal-content custom_modal_drop">
                    <app-videos-instructions></app-videos-instructions>
                </div>
            </div>
        </div>
    </div>
</div> -->
<ng-template #template2>
    <div class="modal-body">
        <div class="model_section p-4">
            <div class="cancel_button_sec text-right mt-4">
            <!--    <a class="close close_button" data-dismiss="modal" aria-label="Close" (click)="closeModal()"> <span class="icon-fill-close1"></span> </a> -->
                <button type="button" class="close close_button" (click)="closeModal()"><span>×</span></button>
                <img src="{{displayImage}}">
                <h5 class="text-center mt-3">{{displayTitle}}</h5>
            </div>
        </div>
    </div>
</ng-template>